import { render, staticRenderFns } from "./PrintPosFacturaSolAmbiental.vue?vue&type=template&id=2ec724d2"
import script from "./PrintPosFacturaSolAmbiental.vue?vue&type=script&lang=js"
export * from "./PrintPosFacturaSolAmbiental.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports